import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  dialogPaper: {
    height: "800px",
    [theme.breakpoints.down("sm")]: {
      height: "100%"
    }
  },

  closeButton: {
    marginRight: theme.spacing(2),
    color: [theme.palette.primary.default, "!important"]
  },
  dialogAction: {
    backgroundColor: "red"
  },
  dialogContent: {
    marginBottom: theme.spacing(2)
  },
  dialogActions: {
    position: "absolute",
    bottom: "0px",
    right: "20px",
    backgroundColor: "white",
    width: "100%"
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/dialogs/CropDialog/styles.js